import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ExchangeMailboxDataResponse, SharePointStorageDataResponse } from "types";
import { apiGet } from "utilities/api";
import {
	EXCHANGE_STORAGE_DATA_FOLDER_PATH,
	SCOPES,
	SHAREPOINT_STORAGE_DATA_FOLDER_PATH,
} from "utilities/constants/constants";

export const fetchSharePointStorageData = createAsyncThunk(
	"cost/fetchSharePointStorageData",
	apiGet<SharePointStorageDataResponse>(
		(authConfig) =>
			authConfig.DATA_LAKE_API_ENDPOINTS.GET_CUSTOMER_DATA(
				SHAREPOINT_STORAGE_DATA_FOLDER_PATH,
			),
		[SCOPES.DATA_LAKE_READ],
	),
);

export const fetchExchangeData = createAsyncThunk(
	"cost/fetchExchangeData",
	apiGet<ExchangeMailboxDataResponse>(
		(authConfig) =>
			authConfig.DATA_LAKE_API_ENDPOINTS.GET_CUSTOMER_DATA(EXCHANGE_STORAGE_DATA_FOLDER_PATH),
		[SCOPES.DATA_LAKE_READ],
	),
);
